<footer class="ft band--ink">
  <div class="av-container av-container--wide">
    <div class="ft__ask">
      <p class="ft__ask-title">{{ 'footer.askTitle' | translate }}</p>
      <div class="ft__ask-ctas">
        <av-cta [cta]="actions().start" location="footer" />
        <av-cta [cta]="actions().demo" [arrow]="false" location="footer" />
      </div>
    </div>

    <div class="ft__top">
      <div class="ft__brand">
        <a [routerLink]="'/' | localePath" [attr.aria-label]="'a11y.home' | translate"
          ><av-logo variant="mono" [height]="32" alt=""
        /></a>
        <p class="ft__pitch">{{ 'footer.pitch' | translate }}</p>
        <p class="ft__trust">
          <av-icon name="microsoft" [size]="14" />
          <span>{{ 'footer.trustLine' | translate }}</span>
        </p>
      </div>

      <nav class="ft__cols" [attr.aria-label]="'a11y.footerNav' | translate">
        @for (col of columns(); track $index) {
          <div class="ft__col">
            <p class="t-mono">{{ col.title }}</p>
            <ul>
              @for (link of col.links; track $index) {
                <li>
                  @if (link.external) {
                    <a
                      [href]="link.href"
                      target="_blank"
                      rel="noopener noreferrer"
                      (click)="reportOutboundLink(link.href)"
                    >
                      {{ link.label }}
                      <av-icon name="arrow-up-right" [size]="12" />
                    </a>
                  } @else {
                    @let to = splitHref(link.href);
                    <a [routerLink]="to.path" [fragment]="to.fragment" [queryParams]="to.query">{{
                      link.label
                    }}</a>
                  }
                  @if (link.children?.length) {
                    <ul class="ft__sub">
                      @for (child of link.children; track $index) {
                        @let childTo = splitHref(child.href);
                        <li>
                          <a
                            [routerLink]="childTo.path"
                            [fragment]="childTo.fragment"
                            [queryParams]="childTo.query"
                            >{{ child.label }}</a
                          >
                        </li>
                      }
                    </ul>
                  }
                </li>
              }
            </ul>
          </div>
        }
      </nav>
    </div>

    <div class="ft__bottom">
      <p class="t-xs">
        {{
          'footer.copyright'
            | translate
              : {
                  year: year,
                  company: site().company.legalName,
                  parent: site().company.parent,
                }
        }}
      </p>
      <ul class="ft__legal">
        <li>
          <a [routerLink]="'/contact' | localePath">{{ 'footer.contact' | translate }}</a>
        </li>
        <!-- A real link to a real file; the dialog is layered on top of it, so
             a modified click, a new tab and a scripting-off visit all still work. -->
        <li>
          <a [href]="privacyHref()" (click)="openPrivacy($event)">{{
            'footer.privacy' | translate
          }}</a>
        </li>
        @if (consent.configured) {
          <li>
            <button type="button" class="ft__legal-action" (click)="consent.reopen()">
              {{ 'footer.cookieSettings' | translate }}
            </button>
          </li>
        }
      </ul>
      <p class="t-xs ft__note">{{ 'footer.trademark' | translate }}</p>
    </div>
  </div>

  <av-legal-dialog
    [href]="privacyHref()"
    [open]="privacyOpen()"
    [label]="'footer.privacy' | translate"
    (closed)="privacyOpen.set(false)"
  />
</footer>
